"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontFamilyMixin = exports.fontWeightMixin = void 0;

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../utils");

var fontWeightMixinBase = function fontWeightMixinBase(_ref) {
  var fontWeight = _ref.fontWeight,
      theme = _ref.theme;
  return (0, _utils.cssPropWithFallthrough)('font-weight', fontWeight, theme.selectors.fontWeight);
};

var fontWeightMixin = (0, _stencilReactDesc.describe)(fontWeightMixinBase).description('Adds a prop for CSS font-weight.');
exports.fontWeightMixin = fontWeightMixin;
fontWeightMixin.propTypes = {
  fontWeight: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'font-weight' property for the element. Only supports named font weights from the Theme.")
};

var fontFamilyMixinBase = function fontFamilyMixinBase(_ref2) {
  var theme = _ref2.theme,
      _ref2$font = _ref2.font,
      font = _ref2$font === void 0 ? 'primary' : _ref2$font;
  return (0, _utils.cssPropWithFallthrough)('font-family', font, theme.selectors.fontFamily);
};

var fontFamilyMixin = (0, _stencilReactDesc.describe)(fontFamilyMixinBase).description('Adds a prop for CSS font-family.');
exports.fontFamilyMixin = fontFamilyMixin;
fontFamilyMixin.propTypes = {
  font: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'font-family' property for the element. Only supports named fonts from the Theme.")
};